var login = new Vue({
    el: '#login-main',
    delimiters: ['${', '}'],
    data: {
        login:true,
        forgetPwd:false
    },
    methods: {
        showPassword(){
            this.login = false;
            this.forgetPwd = true
        },
        hidePwd(){
            this.login = true;
            this.forgetPwd = false
        }
    },
    mounted(){
        console.log('start login')
        console.log(this.login)
    }
})